import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=32f166b6"
import script from "./feedback.vue?vue&type=script&lang=js"
export * from "./feedback.vue?vue&type=script&lang=js"
import style0 from "./feedback.vue?vue&type=style&index=0&id=32f166b6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f166b6')) {
      api.createRecord('32f166b6', component.options)
    } else {
      api.reload('32f166b6', component.options)
    }
    module.hot.accept("./feedback.vue?vue&type=template&id=32f166b6", function () {
      api.rerender('32f166b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/basic/feedback.vue"
export default component.exports